// extracted by mini-css-extract-plugin
export default {"smileyContainer":"smileyscale_smileyContainer__LWc4s","smiley":"smileyscale_smiley__T17Ad","smileyBegoneLeft":"smileyscale_smileyBegoneLeft__HqESB"};